var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('home-left',{staticClass:"page-left"}),_c('home-middle',{staticClass:"page-middle"}),_c('home-right',{staticClass:"page-right"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }